import { render } from "./breadcrumb.vue?vue&type=template&id=639d1ad9&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=639d1ad9&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-639d1ad9"

export default script